var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col px-16 pb-49"},[_c('ChannelCountCell',{ref:"channelCountCellRef"}),_c('TripModeCountCell',{ref:"tripModeCountCellRef",staticClass:"mt-4"}),_c('OriginCountCell',{ref:"originCountCellRef",staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }